import { useAppSelector } from '@/shared/hooks/store';
import { selectIsApChatEnabled } from '@/store/slices/auth/selectors';

export const useChatClassName = (): string => {
    // Mirrors the exact condition that renders <ChatWidget> so the class never points at a widget that isn't mounted.
    const isAIChatEnabled = useAppSelector(selectIsApChatEnabled);
    return isAIChatEnabled ? 'ameripharma-chat' : 'intercom-launcher';
};
